import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

import type { ClaimContext as ClaimInfoContext } from './ClaimInfo/types';

interface ClaimContextType {
  claimInfo: ClaimInfoContext | null;
  handleChatMessage: (message: string) => Promise<void>;
  claimNumber?: string;
}

export const ClaimContext = createContext<ClaimContextType | null>(null);

export const useClaimContext = () => {
  const ctx = useContext(ClaimContext);
  if (!ctx) throw new Error('useClaimContext must be used within a ClaimProvider');
  return ctx;
};

interface ClaimProviderProps extends ClaimContextType {
  children: ReactNode;
}

export const ClaimProvider: React.FC<ClaimProviderProps> = ({ children, ...value }) => (
  <ClaimContext.Provider value={value}>{children}</ClaimContext.Provider>
);
